import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=2ce9670a&scoped=true"
import script from "./CustomerTables.vue?vue&type=script&lang=js"
export * from "./CustomerTables.vue?vue&type=script&lang=js"
import style0 from "./CustomerTables.vue?vue&type=style&index=0&id=2ce9670a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9670a",
  null
  
)

export default component.exports